export default __webpack_public_path__ + "00cc17fa510d1070ea96d8e612dcad57.png";